import { asyncDelay } from '@/services/asyncHelpers';
import store from '@/store';
import callRefreshIfNeeded from '@/services/http/interceptors/refreshInterceptor';
import axiosFactory from '../axiosFactory';
import { isRetryableResponse, DEFAULT_MAX_RETRIES, DEFAULT_RETRY_INTERVAL } from '../common';

function getMaxRetries(options) {
  return options.maxRetries != null ? options.maxRetries : DEFAULT_MAX_RETRIES;
}

function getRetryInterval(options) {
  return options.interval != null ? options.interval : DEFAULT_RETRY_INTERVAL;
}

function canRetry(options, response, retries) {
  return retries < getMaxRetries(options) // Na primeira será um nulo
    && isRetryableResponse(response);
}

export default async function retryInterceptor(options, error) {
  let retries = 0;
  if (!error.response || !canRetry(options, error.response, retries)) {
    return Promise.reject(error);
  }

  await callRefreshIfNeeded(error.response);

  const instance = axiosFactory();
  let lastError;
  const setLastError = (newError) => {
    lastError = newError;
  };
  let successfulResponse;
  const setSuccessfulResponse = (response) => {
    successfulResponse = response;
  };
  // Desabilitando o 'no-await-in-loop' pois o loop não é para processamento, e sim para esperar
  // de maneira repetitiva.
  do {
    // eslint-disable-next-line no-await-in-loop
    await asyncDelay(getRetryInterval(options));
    retries += 1;

    const newToken = `Bearer ${store.getters.token}`;

    const { headers } = error.config;
    headers.Authorization = newToken ?? headers.Authorization;

    // eslint-disable-next-line no-await-in-loop
    await instance.request({
      ...error.config,
      ...{ headers },
      url: error.config.$originalUrl || error.config.url,
    }).then(setSuccessfulResponse)
      .catch(setLastError);
  } while (!successfulResponse
    && lastError.response
    && canRetry(options, lastError.response, retries));

  if (successfulResponse) {
    return successfulResponse;
  }

  // eslint-disable-next-line prefer-promise-reject-errors
  return Promise.reject(lastError);
}
